import GoogleAnalyticApisService from '@package/core/src/googleAnalytics/GoogleAnalyticApisService';
import GoogleAnalyticsInteractor from '@package/core/src/googleAnalytics/GoogleAnalyticsInteractor';
import {
  PageviewRequest,
  CheckoutProcessRequest,
  AddProductToCartRequest,
  AddSelectedPaymentRequest,
  AddProductServiceToCartRequest,
  RemoveProductFromCartRequest,
  PurchasesRequest,
} from '@package/core/src/googleAnalytics/types';


const googleAnalyticApisService = new GoogleAnalyticApisService();
const googleAnalyticsInteractor = new GoogleAnalyticsInteractor(googleAnalyticApisService);

const pageview = (request: PageviewRequest) => googleAnalyticsInteractor.pageview(request);

const initCheckoutProcess = (request: CheckoutProcessRequest) => googleAnalyticsInteractor.initCheckoutProcess(request);

const addProductToCart = (request: AddProductToCartRequest) => googleAnalyticsInteractor.addProductToCart(request);

const addSelectedPayment = (request: AddSelectedPaymentRequest) =>
  googleAnalyticsInteractor.addSelectedPayment(request);

const addProductServiceToCart = (request: AddProductServiceToCartRequest) =>
  googleAnalyticsInteractor.addProductServiceToCart(request);

const removeProductFromCart = (request: RemoveProductFromCartRequest) =>
  googleAnalyticsInteractor.removeProductFromCart(request);

const purchases = (request: PurchasesRequest) => googleAnalyticsInteractor.purchases(request);

const useGoogleAnalytics = () => ({
  pageview,
  initCheckoutProcess,
  addProductToCart,
  addSelectedPayment,
  addProductServiceToCart,
  removeProductFromCart,
  purchases,
});

export default useGoogleAnalytics;
